// pr-display — constantes/helpers de exibição de PR, compartilhados (DEM-2037).
//
// Separado de PullRequestCard.tsx pra satisfazer react-refresh/only-export-
// components (um arquivo .tsx de componente não pode exportar também constantes
// e funções). PullRequestsPage e a aba PRs do DemandDetailPanel importam daqui.

import { GitPullRequest, GitBranch, CheckCircle2, XCircle, Eye } from 'lucide-react';
import type { PullRequest, PRStatus } from '@/lib/api';

export const PR_STATUS_CONFIG: Record<
  PRStatus,
  {
    label: string;
    variant: 'default' | 'warning' | 'info' | 'success' | 'danger' | 'brand';
    icon: typeof GitPullRequest;
  }
> = {
  draft: { label: 'Draft', variant: 'default', icon: GitPullRequest },
  open: { label: 'Open', variant: 'info', icon: GitPullRequest },
  review: { label: 'In Review', variant: 'warning', icon: Eye },
  approved: { label: 'Approved', variant: 'success', icon: CheckCircle2 },
  merged: { label: 'Merged', variant: 'brand', icon: GitBranch },
  closed: { label: 'Closed', variant: 'danger', icon: XCircle },
};

/**
 * Monta a URL do PR no GitHub a partir das colunas reais. Preferimos
 * external_id (quando o produtor gravou a URL completa); senão derivamos de
 * `repo` (owner/name) + `pr_number`. Sem dados suficientes → null (sem link).
 */
export function githubPrUrl(pr: PullRequest): string | null {
  if (pr.external_id && /^https?:\/\//.test(pr.external_id)) return pr.external_id;
  if (pr.repo && pr.repo.includes('/') && pr.pr_number != null) {
    return `https://github.com/${pr.repo}/pull/${pr.pr_number}`;
  }
  return null;
}
